import './Style/Connection.style.css'
import { Form, Input, Button, Alert } from "antd";
import { useState } from 'react';
import {api} from '../helper/axios/index'
import logo from '../assets/images/connection3.svg'
import { Link } from 'react-router-dom';
import { ArrowRightOutlined , ArrowLeftOutlined} from '@ant-design/icons';
import {useNavigate} from 'react-router-dom';



export const Connection = ()=>{
    const navigate = useNavigate();
    const ENDPOINT = "auth0/login";
    const [error, setError] = useState(null);
    const [afficheError, setAfficheError] = useState(false);
    const handleLogin = async (email, password) => {
        try {
          const response = await api.post(ENDPOINT, {
            email: email,
            password: password,
          });
          if(response.data.user.agent == null){
            sessionStorage.setItem("utilisateurs", JSON.stringify(response.data));
            console.log('Réponse du serveur:', response.data);
            navigate('/');
          }else{
            setAfficheError(true)
            console.log("Vous ête un agent")
            setError(
            <Alert
            message={"Cette interface est réservée exclusivement aux contribuables"}
            type="error"
            showIcon
          />)
          setTimeout(() => {
            setAfficheError(false);
        }, 3000);
          }  
        } catch (error) {

            if(error){
                console.log(error)
                setAfficheError(true)
            }
            console.error(error?.response?.data?.message?.[0]);
          setError(
          <Alert
      message={error?.response?.data?.message?.[0]}
      type="error"
      showIcon
    />)
      // Supprimez le message d'erreur après trois secondes.
      setTimeout(() => {
        setAfficheError(false);
    }, 3000);
      };
        }
        const [loading, setLoading] = useState(false);
      
        const onFinish = async (values) => {
          setLoading(true);
          const { email, password } = values;
          console.log(email +" + " + password)
          await handleLogin(email, password);
          setLoading(false);
        };
    
    return(
        <>
           
           <div className="container d-flex justify-content-center align-items-center min-vh-100">
        {/*--------------------- Login Container ------------------------*/}
        <div className="row border rounded-5 p-3 bg-white shadow box-area">
          {/*------------------------- Left Box ---------------------------*/}
          <div className='col-md-12 d-flex justify-content-start align-items-center'>
            {/* <span style={{position: "relative"}}> 
            <ArrowLeftOutlined />
            </span> */}
         
          <Button
          onClick={()=>navigate('/')}
          type="primary"
          icon={<ArrowLeftOutlined/>}
          style={{background: '#6C63FF', width: "16em", display: "flex", alignItems:"center",justifyContent: "center"}}
        >
          <span> Retour à la page d'accueil</span>
        </Button>
          </div>
         
          <div className="col-md-6 rounded-4 d-flex justify-content-center align-items-center flex-column left-box" style={{background: '#fff'}}>
            <div className="featured-image mb-3">
              <img src={logo} className="img-fluid" style={{width: '200px'}} />
            </div>
            {/* <small className="text-grey text-wrap text-center" style={{width: '17rem', fontFamily: '"Courier New", Courier, monospace'}}>Veuillez vérifier votre compte en tant que Contribuable pour profiter pleinement de notre application de gestion des contribuables.</small> */}
          </div> 
          {/*------------------ ------ Right Box --------------------------*/}
          <div className="col-md-6 right-box">
            <div className="row align-items-center">
              <div className="header-text mb-4">
               
                <p className='text-center'>Veuillez vérifier votre compte en tant que Contribuable pour profiter pleinement de notre application de gestion des contribuables</p>
              </div>

              {afficheError && <div className="error-message mb-3">{error}</div>}

                {/* Ant design */}

                <Form
      
      onFinish={onFinish}
      layout="vertical"
     
    >
      <Form.Item
        name="email"
        label="Email"
        rules={[
            { required: true, message: 'Veuillez entrer votre adresse email !' },
            { type: 'email', message: 'Adresse email invalide !' }
        ]}
      >
        <Input
          placeholder="Entrer entrer votre adresse email"
          autoFocus
         
        />
      </Form.Item>
      <Form.Item
        name="password"
        label="Mot de passe"
        rules={[{ required: true, message: 'Veuillez entrer votre mot de passe !' },
        { min: 4, message: 'Le mot de passe doit contenir au moins 4 caractères !' }]}
      >
        <Input.Password
          placeholder="Entrer votre mot de passe"
         
        />
      </Form.Item>
      <div className="d-flex justify-content-center">
        <Button
          type="primary"
          icon={<ArrowRightOutlined />}
          htmlType="submit" loading={loading}
          style={{background: '#6C63FF', width: "12em",display: "flex", alignItems:"center", justifyContent: "center"}}
        >
         Connexion
        </Button>
      </div>
    </Form>

                <div className="row text-center mt-5">
                <small>Vous n'avez pas de compte ?  <Link to="/inscription"  style={{color: '#6C63FF'}}>S'inscrire</Link></small>
              </div>
            </div>
          </div> 
        </div>
      </div>
 
        </>
    )
}